/* eslint-disable react/prefer-es6-class, default-case, react/sort-comp, arrow-body-style, quote-props, react/jsx-no-bind, react/prop-types */
import classnames from 'classnames';
import React from 'react';
import { DropdownSessionSize, DropdownItemSource, DropdownGoalSource } from 'es6/components/apps/session-config-dropdown';
import ItemPreview from 'es6/components/apps/item-preview';
import ItemSummary from 'es6/components/apps/item-summary';
import Keys from 'es6/core/keys';
import { t } from 'es6/services/localization';
import MemoryBank from 'es6/components/apps/memory-bank';
import { NavButton, NavContainer, Navigation } from 'es6/components/apps/navigation';
import ProgressBar from 'es6/components/common/progress-bar';
import PremiumLink from 'es6/components/apps/premium-link';
import * as SoundEffects from 'es6/core/sound-effects';
import SoundManager from 'es6/services/sound-manager';

export const Panels = {
  Progress: 'report-panel',
  Difficulty: 'difficulty',
  SessionPreview: 'session-items-panel',
  SessionSummary: 'items-summary-panel',
};

/**
 * The memory bank summary screen component. This handles the
 * rendering of a memory bank plot, along with toggles to
 * change the panels between progress, difficulty, item preview
 * and item summary.
 *
 * This is a pretty complex component that is stateful, performs
 * animations and takes in a lot of properties to render subcomponents.
 * Please above propTypes for property details.
 */
export const MemoryBankSummaryScreen = React.createClass({
  displayName: 'MemoryBankSummaryScreen',

  /**
   * applicationType: which app is being used
   * courseRecommendation: object with goal and aggregate memory of course to recommend
   * onCourseRecommendationShow: callback method for showing the course recommendation
   * onCourseRecommendationSkip: callback method for skipping the course recommendation
   * isCheckpoint: will render a checkpoint overlay and navigation
   * isCourseCompleted: will render a course completed overlay and navigation
   * isPremiumUser: don't show session settings
   * isStudyAll: used to display difficulty panel, different screen banner and goal source
   * hasFinishedSession: indicates whether the user is coming back from a session
   * onCheckpointRedirect: callback for the user triggering checkpoint
   * onCheckpointSkip: callback for a user declining the checkpoint
   * onMasterItem: callback passed to summary component
   * onMenu: callback to navigate back to the app launcher
   * onNext: callback for course completed navigation
   * onGoalSourceChange:callback for when goal source changes
   * onItemSourceChange: callback for when item source changes
   * onSessionSizeChange: callback for session size changes
   * onStart: callback for when the user clicks to start the app
   * onSkipItems: callback used by item preview component
   * memoryBankPlot: instance of MemoryBankPlot object containing SVG
   * sessionConfig: instance of SessionConfig object
   * sessionData: object containing information of upcoming session
   * startLabel: label for the start button
   * updatedMemories: array of memory changes from the last session
   */
  propTypes: {
    applicationType: React.PropTypes.string,
    courseRecommendation: React.PropTypes.object,
    onCourseRecommendationShow: React.PropTypes.func,
    onCourseRecommendationSkip: React.PropTypes.func,
    isCheckpoint: React.PropTypes.bool,
    isCourseCompleted: React.PropTypes.bool,
    isPremiumUser: React.PropTypes.bool.isRequired,
    isStudyAll: React.PropTypes.bool,
    hasFinishedSession: React.PropTypes.bool,
    onCheckpointRedirect: React.PropTypes.func,
    onCheckpointSkip: React.PropTypes.func,
    onMasterItem: React.PropTypes.func.isRequired,
    onMenu: React.PropTypes.func.isRequired,
    onNext: React.PropTypes.func.isRequired,
    onGoalSourceChange: React.PropTypes.func.isRequired,
    onItemSourceChange: React.PropTypes.func.isRequired,
    onSessionSizeChange: React.PropTypes.func.isRequired,
    onStart: React.PropTypes.func.isRequired,
    onSkipItems: React.PropTypes.func,
    memoryBankPlot: React.PropTypes.object.isRequired,
    sessionConfig: React.PropTypes.object.isRequired,
    sessionData: React.PropTypes.object.isRequired,
    startLabel: React.PropTypes.string.isRequired,
    updatedMemories: React.PropTypes.array,
  },

  getDefaultProps() {
    return {
      courseRecommendation: null,
      onCourseRecommendationShow: null,
      onCourseRecommendationSkip: null,
      isCheckpoint: false,
      isCourseCompleted: false,
      isPremiumUser: false,
      isStudyAll: false,
      hasFinishedSession: false,
      onCheckpointRedirect: null,
      onCheckpointSkip: null,
      onSkipItems: null,
      updatedMemories: [],
    };
  },

  getInitialState() {
    return {
      bannerOverlay: null,
      itemPackages: _.values(this.props.sessionData.itemPackages),

      // Used to delay animations.
      enableSessionSummary: false,
      hasMounted: false,

      // Generated when the component mounts.
      memoryBankVisual: 'progress',

      panel: Panels.Progress,

      skippedItemIds: [],
    };
  },

  /**
   * Because animations are impossible to do when mounting a component, we set
   * the hasMounted flag to true (which will re-render with animatable CSS
   * classes).
   */
  componentWillMount() {
    // Play the appropriate sound on mount.
    if (this.props.isCourseCompleted) {
      SoundManager.playEffect(SoundEffects.COURSE_COMPLETION);
    } else if (this.props.isCheckpoint) {
      SoundManager.playEffect(SoundEffects.CHECKPOINT);
    } else if (this.props.hasFinishedSession) {
      SoundManager.playEffect(SoundEffects.DONE);
    } else {
      SoundManager.playEffect(SoundEffects.WELCOME);
    }

    this.setState({ hasMounted: true });
  },

  /**
   * The skipped items queue should also be reset, as the results will
   * change for the skipped items panel.
   */
  componentWillReceiveProps(nextProps) {
    this.setState({
      // Need to keep a copy of the previous banner overlay so
      // it does not impact the animation.
      bannerOverlay: this._getOverlayMessage(),
      itemPackages: _.values(nextProps.sessionData.itemPackages),
      skippedItemIds: [],
    });
  },

  /**
   * Logic for determining if the render item preview panel
   * and panel tab can be rendered.
   */
  _canRenderItemSummary() {
    return this.props.updatedMemories.length > 0;
  },

  /**
   * Get the appropriate overlay message.
   *
   * @returns {String}
   */
  _getOverlayMessage() {
    if (this.props.isCourseCompleted && this.props.courseRecommendation) {
      return this._isCourseRecommendationNew() ?
        t('course-completed-overlay-message-new') :
        t('course-completed-overlay-message-next');
    } else if (this.props.courseRecommendation) {
      // Show a different message depending on if the overlay is new.
      return this._isCourseRecommendationNew() ?
        t('recommendation-overlay-message-new') :
        t('recommendation-overlay-message-next');
    } else if (this.props.isCourseCompleted) {
      return t('course-completed-overlay-message');
    } else if (this.props.isCheckpoint) {
      return t('checkpoint-overlay-message');
    }

    return null;
  },

  /**
   * If the user switches panels, reset the items to skip.
   * If the user is switching to the summary panel for
   * the first time, set enableSessionSummary to true, which
   * will render the session summary component, triggering the
   * animations.
   *
   * @param {String} panel    one of the Panel options
   */
  _handlePanelSwitch(panel) {
    let memoryBankVisual = this.state.memoryBankVisual;
    let enableSessionSummary = this.state.enableSessionSummary;

    switch (panel) {
      case Panels.Difficulty:
        memoryBankVisual = 'difficulty';
        break;
      case Panels.Progress:
        memoryBankVisual = 'progress';
        break;
      case Panels.SessionSummary:
        enableSessionSummary = true;
        break;
    }

    this.setState({
      enableSessionSummary,
      memoryBankTransitionType: 'default',
      memoryBankVisual,
      panel,
      skippedItemIds: [],
    });
  },

  /**
   * Maintains some state for the item preview component. Will only
   * send back all the skipped items once the user performs the skip
   * action.
   *
   * @param {Number[]} skippedItemIds
   */
  _handleSkipped(skippedItemIds) {
    this.setState({ skippedItemIds });
  },

  /**
   * Returns true if the recommended course is a new course. Will
   * return false if there is no recommended course present (as a fallback).
   *
   * @returns {Boolean}
   */
  _isCourseRecommendationNew() {
    const courseRecommendation = this.props.courseRecommendation;

    return !courseRecommendation || !courseRecommendation.aggregateMemory || !courseRecommendation.aggregateMemory.startedAt;
  },

  render() {
    // Check to see if the component has mounted, otherwise the animation
    // will be lost.
    const className = classnames('screen screen-memory-bank-summary', {
      'screen-overlay': this.state.hasMounted && this._getOverlayMessage() !== null,
    });

    return (
      <div className={className}>

        <div className="screen-content">

          {this._renderOverlay()}

          <header className="panel-navigation-container">
            <span className="memory-bank-logo" />
            <span className="loading-spinner" />

            <div className="panel-menu-container">
              <nav className="panel-menu">
                <ul className="choice-set">
                  {this._renderPanelTab(Panels.Progress)}
                  {this._renderPanelTab(Panels.Difficulty)}
                  {this._renderPanelTab(Panels.SessionPreview)}
                  {this._renderPanelTab(Panels.SessionSummary)}
                </ul>

                <a href="#memory-bank-help" className="btn btn-bar memory-bank-help" data-modal-link title={t('memory-bank-help-title')}>
                  {t('memory-bank-help.label')}
                </a>
              </nav>

              {this._renderReadyStatisticsTab()}
              {this._renderMainStatisticsTab()}
            </div>
          </header>

          <div className="panels">
            {this._renderMemoryBankPanel()}
            {this._renderItemPreviewPanel()}
            {this._renderItemSummaryPanel()}
          </div>
        </div>

        {this._renderNavigation()}
      </div>
    );
  },

  _renderCourseRecommendationNavigation() {
    const showButtonText = this._isCourseRecommendationNew() ? t('start-new') : t('start-next');

    return (
      <Navigation>
        <NavButton align="left" onClick={this.props.onMenu}>{t('js_iknow.menu')}</NavButton>
        <NavButton align="right" onClick={this.props.onCourseRecommendationSkip}>{t('skip-recommended')}</NavButton>
        <NavButton align="right" focused onClick={this.props.onCourseRecommendationShow}>{showButtonText}</NavButton>
      </Navigation>
    );
  },

  _renderReadyStatisticsTab() {
    return (
      <div className="statistics-tab statistics-tab-ready">
        <div className="primary">{getAggregateData(this.props.isStudyAll, this.props.sessionData).items.eligibleItemsCount}</div>
        <div className="secondary">{t('ready-banner')}</div>
      </div>
    );
  },

  _renderMainStatisticsTab() {
    const aggregateData = getAggregateData(this.props.isStudyAll, this.props.sessionData);

    if (this.props.isStudyAll) {
      return (
        <div className="statistics-tab statistics-tab-mastered">
          <div className="primary">{aggregateData.items.itemsAtCheckpoint2}</div>
          <div className="secondary">{t('mastered-banner')}</div>
        </div>
      );
    } else {
      const goal = getCurrentGoal(this.props.sessionData);
      const totalCount = goal.getTotalItemsCount(aggregateData);
      const allStarted = totalCount === aggregateData.items.studiedItemsCount;
      const className = classnames('statistics-tab', {
        'statistics-tab-mastered': allStarted,
        'statistics-tab-started': !allStarted,
      });

      let primary = aggregateData.items.studiedItemsCount;
      let message = t('started-banner');

      if (allStarted) {
        primary = aggregateData.items.itemsAtCheckpoint2;
        message = t('mastered-banner');
      }

      return (
        <div className={className}>
          <div className="primary">
            {primary}
            <span className="total-count">/{totalCount}</span>
          </div>
          <div className="secondary">{message}</div>
        </div>
      );
    }
  },

  /**
   * Do one of two things:
   *
   * 1) Either show the current overlay message, that reflects the current
   *    state of the memory bank.
   * 2) Show the previous banner overlay, so the message does not disappear
   *    when animating.
   */
  _renderOverlay() {
    const message = this._getOverlayMessage() || this.state.bannerOverlay || '';
    const className = classnames('overlay', {
      'overlay-progress-visual': this.state.panel === Panels.Progress,
    });

    return (
      <div className={className}>
        <div className="overlay-message" dangerouslySetInnerHTML={{ __html: message }} />
      </div>
    );
  },

  _renderCheckpointNavigation() {
    return (
      <Navigation>
        <NavButton align="left" onClick={this.props.onMenu}>{t('js_iknow.menu')}</NavButton>

        <NavButton align="right" onClick={this.props.onCheckpointSkip}>{t('checkpoint-skip')}</NavButton>
        <NavButton align="right" focused onClick={this.props.onCheckpointRedirect}>{t('checkpoint-redirect')}</NavButton>
      </Navigation>
    );
  },

  _renderItemPreviewPanel() {
    let className = classnames('panel items-preview-container', {
      hidden: this.state.panel !== Panels.SessionPreview,
    });

    const itemPreviewProps = {
      itemPackages: _.pluck(this.props.sessionData.studySession, 'content'),
      onSkipped: this._handleSkipped,
      skippedItemIds: this.state.skippedItemIds,
    };

    return (
      <div className={className}>
        <ItemPreview {...itemPreviewProps} />
      </div>
    );
  },

  /**
   * Postpone rendering the panel until the user clicks on the panel. This will
   * ensure that any animations occur then.
   */
  _renderItemSummaryPanel() {
    if (!this._canRenderItemSummary() || !this.state.enableSessionSummary) {
      return null;
    }

    let className = classnames('panel items-summary-container', {
      hidden: this.state.panel !== Panels.SessionSummary,
    });

    let itemPackages = _.map(this.props.updatedMemories, memory => {
      return this.props.sessionData.itemPackages[memory.contentId];
    });

    return (
      <div className={className}>
        <ItemSummary itemPackages={itemPackages} onComplete={this.props.onMasterItem} />
      </div>
    );
  },

  _renderMemoryBankPanel() {
    let className = classnames('panel memory-bank-container', {
      hidden: this.state.panel !== Panels.Progress && this.state.panel !== Panels.Difficulty,
    });

    return (
      <div className={className}>
        <MemoryBank memoryBankPlot={this.props.memoryBankPlot} visual={this.state.memoryBankVisual} />
      </div>
    );
  },

  /**
   * Renders a panel tab.
   *
   * @param {String} panel     one of strings defined in the constant above
   */
  _renderPanelTab(panel) {
    const className = classnames(`choice choice-${panel}`, { 'selected': this.state.panel === panel });
    let body;

    switch (panel) {
      case Panels.Progress:
        body = t('js_iknow.report-panel');
        break;
      case Panels.Difficulty:
        body = t('js_iknow.difficulty');
        break;
      case Panels.SessionPreview:
        body = t('session-items-panel');
        break;
      case Panels.SessionSummary:
        body = t('items-summary-panel');
        break;
    }

    // Don't render the session summary tab if the summary panel isn't going to
    // be rendered.
    if (panel === Panels.SessionSummary && !this._canRenderItemSummary()) {
      return null;
    }

    // Don't render difficulty layout when component is used with study all.
    if (panel === Panels.Difficulty && this.props.isStudyAll) {
      return null;
    }

    return (
      <li onClick={this._handlePanelSwitch.bind(null, panel)} className={className}>{body}</li>
    );
  },

  _renderNavigation() {
    if (this.props.isCourseRecommendation) {
      return this._renderCourseRecommendationNavigation();
    } else if (this.props.isCourseCompleted) {
      return this._renderCourseCompletedNavigation();
    } else if (this.props.isCheckpoint) {
      return this._renderCheckpointNavigation();
    } else if (this.props.sessionData.studySession.length === 0) {
      return this._renderNoItemsNavigation();
    } else if (this.state.skippedItemIds.length > 0) {
      return this._renderSkippedNavigation();
    }

    return this._renderDefaultNavigation();
  },

  /**
   * Will render the session configuration or sign up for a premium
   * account link.
   */
  _renderSessionConfiguration() {
    if (!this.props.isPremiumUser) {
      return (<PremiumLink source={this.props.applicationType} />);
    }

    return (
      <NavContainer align="right" className="settings-wrapper">
        {this._renderGoalSourceConfig()}

        <div className="settings-block settings-block-item-source">
          <span className="setting-label">{t('js_iknow.item-source')}</span>
          <DropdownItemSource onChange={this.props.onItemSourceChange} sessionConfig={this.props.sessionConfig} />
        </div>

        <div className="settings-block settings-block-session-size">
          <span className="setting-label">{t('session-size-max-label')}</span>
          <DropdownSessionSize onChange={this.props.onSessionSizeChange} sessionConfig={this.props.sessionConfig} sizes={this.props.sessionSizes} />
        </div>
      </NavContainer>
    );
  },

  _renderGoalSourceConfig() {
    if (!this.props.isStudyAll) {
      return null;
    }

    return (
      <div className="settings-block settings-block-goal-source">
        <span className="setting-label">{t('goal-source')}</span>
        <DropdownGoalSource onChange={this.props.onGoalSourceChange} sessionConfig={this.props.sessionConfig} />
      </div>
    );
  },

  _renderCourseCompletedNavigation() {
    return (
      <Navigation>
        <NavButton align="left" onClick={this.props.onMenu}>{t('js_iknow.menu')}</NavButton>
        <NavButton align="right" keyCode={Keys.ENTER} focused onClick={this.props.onNext}>{t('js_iknow.next')}</NavButton>
      </Navigation>
    );
  },

  _renderDefaultNavigation() {
    const { startLabel } = this.props;

    return (
      <Navigation>
        <NavButton align="left" onClick={this.props.onMenu}>{t('js_iknow.menu')}</NavButton>
        {this._renderSessionConfiguration()}
        <NavButton align="right" keyCode={Keys.ENTER} focused onClick={this.props.onStart}>{startLabel}</NavButton>
      </Navigation>
    );
  },

  _renderNoItemsNavigation() {
    const { startLabel } = this.props;

    return (
      <Navigation>
        <NavButton align="left" onClick={this.props.onMenu}>{t('js_iknow.menu')}</NavButton>
        {this._renderSessionConfiguration()}
        <NavButton align="right" disabled>{startLabel}</NavButton>
      </Navigation>
    );
  },

  _renderSkippedNavigation() {
    return (
      <Navigation>
        <NavButton align="left" onClick={this.props.onMenu}>{t('js_iknow.menu')}</NavButton>
        <NavButton align="right" onClick={this.props.onSkipItems.bind(null, this.state.skippedItemIds)}>{t('js_iknow.reload')}</NavButton>
      </Navigation>
    );
  },
});

/**
 * Helper method to get the aggregate data for study all or single
 * course.
 *
 * @returns {AggregateMemory|Grouping}
 */
function getAggregateData(isStudyAll, sessionData) {
  return isStudyAll ?
    sessionData.grouping :
    sessionData.aggregateMemories[0];
}

function getCurrentGoal(sessionData) {
  return sessionData.goals[0];
}

// The screen banner will be rendered at a different location in the DOM, so
// expose a stateless component that the controller can use to render it.
export function MemoryBankSummaryBanner(props) {
  let bannerContent = null;
  let progress = null;

  if (props.isStudyAll) {
    bannerContent = (<span className="study-all-title">{t('study-all.label')}</span>);
  } else {
    const aggregateMemory = getAggregateData(props.isStudyAll, props.sessionData);

    if (aggregateMemory.completed) {
      progress = (<span className="course-completed-message">{t('course completed')}</span>);
    } else {
      progress = (<ProgressBar progress={aggregateMemory.items.progress} showProgressTag />);
    }

    bannerContent = (<span className="course-title">{getCurrentGoal(props.sessionData).title}</span>);
  }

  return (
    <div className="screen-memory-bank-summary-banner">{bannerContent} {progress}</div>
  );
}

export default MemoryBankSummaryScreen;
